import baseRequestHandler from './baseRequestHandler'
// import authRequestHandler from './authRequestHandler'
import baseResponseHandler from './baseResponseHandler'
import errorResponseHandler from './errorResponseHandler'

export const requestHandler = {
  baseRequestHandler
}
export const responseHandler = {
  baseResponseHandler,
  errorResponseHandler
}

export default {
  requestHandler,
  responseHandler
}
